"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true if the provided date string has dd/MM/yyyy format.
 */
function isSimpleDate(dateString) {
    return /^([0-2]\d|(3)[0-1])(\/)(((0)\d)|((1)[0-2]))(\/)\d{4}$/.test(dateString);
}
exports.default = isSimpleDate;
//# sourceMappingURL=isSimpleDate.js.map